import { FC, useState } from 'react'
import styles from './EditPlatformCardFilesBlock.module.css'
import TitleBlockForEditPages from '../TitleBlockForEditPages/TitleBlockForEditPages'
import deleteIcon from '../../assets/icons/IconTrashGray.svg'
import iconDoc from '../../assets/icons/iconDoc.svg'
import loadIcon from '../../assets/icons/download.svg'
import CustomButton from '../UI/CustomButton/CustomButton'
import { EstablishmentsType, PlaceType } from '../../redux/actions/types'
import UploadFileComponent from '../UploadFileComponent/UploadFileComponent'
import PATH from '../../navigation/path'
import { useNavigate } from 'react-router-dom'
import {
  deleteCurrentFileFromPlatform,
  getCurrentPlaces,
  pushNewFilesToPlatform,
} from '../../redux/actions/placesAction'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { useToast } from '../../context/ToastContext'
export type EditPlatformCardFilesBlockPropsType = {
  platformData: PlaceType | EstablishmentsType
}

const EditPlatformCardFilesBlock: FC<EditPlatformCardFilesBlockPropsType> = ({ platformData }) => {
  const [files, setFiles] = useState<any>([])

  const { token } = useAppSelector((state) => state.auth)

  const dispatch = useAppDispatch()

  const navigate = useNavigate()

  const { showSuccess, showError } = useToast()

  const handleDeleteFileFromServer = async (fileName: string) => {
    const resultAction = await dispatch(
      deleteCurrentFileFromPlatform({
        token,
        placeId: String(platformData.id),
        filesToDelete: [fileName],
      }),
    )

    if (deleteCurrentFileFromPlatform.rejected.match(resultAction)) {
      showError('Произошла ошибка при удалении файла')
    } else {
      showSuccess('Файл успешно удален')
      await dispatch(getCurrentPlaces({ placeId: String(platformData.id), token }))
    }
  }

  const handleSubmit = async () => {
    const formData = new FormData()

    if (files.length > 10) {
      showError('Вы можете загрузить максимум 10 картинок')

      return
    }

    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i])
      }
      const resultAction = await dispatch(
        pushNewFilesToPlatform({ placeId: String(platformData.id), formData, token }),
      )

      if (pushNewFilesToPlatform.rejected.match(resultAction)) {
        showError('Произошла ошибка при добавлении файла')
      } else {
        showSuccess('Файл успешно добавлен')
        setFiles([])
        await dispatch(getCurrentPlaces({ placeId: String(platformData.id), token }))
      }
    }
  }

  const handleReset = () => {
    navigate(`${PATH.platformCardPage}${platformData.id}`)
  }

  return (
    <>
      <div className={styles.editFiles}>
        <div className={styles.btnsBlockWrapper}>
          <TitleBlockForEditPages
            title='Файлы'
            disabled={files.length === 0}
            handleSubmit={handleSubmit}
            handleReset={handleReset}
          />
          <div className={styles.btnsBlock}>
            <CustomButton
              type='reset'
              onClick={handleReset}
              title='Отменить'
              className={styles.cancelBtn}
            />
            <CustomButton
              title='Сохранить'
              disabled={files.length === 0}
              onClick={handleSubmit}
              type='submit'
              className={styles.saveBtn}
            />
          </div>
        </div>
        <div className={styles.filesBlock}>
          <UploadFileComponent setFiles={setFiles} filesArray={files} />
          {(platformData as PlaceType).files.length !== 0 &&
            (platformData as PlaceType).files.map((f, index) => {
              return (
                <div key={index} className={styles.fileBlock}>
                  <div className={styles.nameBlock}>
                    <img className={styles.fileIcon} src={iconDoc} alt='fileIcon' />
                    <p className={styles.fileName}>{f}</p>
                  </div>
                  <div className={styles.iconsBlock}>
                    <img
                      onClick={() => handleDeleteFileFromServer(f)}
                      className={styles.deleteIcon}
                      src={deleteIcon}
                      alt='deleteIcon'
                    />
                    <a
                      className={styles.loadIcon}
                      href={`${process.env.REACT_APP_BASE_URL_IMAGES}${f}`}
                      target='_blank'
                      rel='noreferrer'
                    >
                      <img className={styles.loadIcon} src={loadIcon} alt='loadIcon' />
                    </a>
                  </div>
                </div>
              )
            })}
        </div>
      </div>
    </>
  )
}

export default EditPlatformCardFilesBlock
